import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NdaModal from "./dialog/nda_modal";
import { Text } from "../themes/userq/Text/Text";
import { Icon } from "../themes/userq/Icon/Icon";
import { Button } from "../themes/userq/Button/Button";
import ScreenRecordingPermissionModal from "./dialog/screen_recording_permission_modal";
import "./introduction.css";

export default function Introduction({
    test,
    result,
    isNda,
    score,
    isPaidUser,
    isRegisteredUser,
    introductionCallback,
    timeSpent,
    testerNotMatchedInTargetGroup,
    testerLimitExceed,
    permissionGranted,
    isUnsupportedBrowser = false,
}) {
    const location = useLocation();
    const [openNdaModal, setOpenNdaModal] = useState(false);
    const [checkNda, setCheckNda] = useState(false);
    const [openPermissionModal, setOpenPermissionModal] = useState(false);
    const [allowedToGiveTest, setAllowedToGiveTest] = useState(false);

    const closeNdaModal = (data) => {
        setOpenNdaModal(false);
        if (data) {
            setCheckNda(true);
        }
        if (test.is_screen_recording_enabled === 1) {
            setOpenPermissionModal(true);
        } else {
            setAllowedToGiveTest(true);
        }
    };

    const closePermissionModal = () => {
        setOpenPermissionModal(false);
    };
    const handlepermissionModal = () => {
        closePermissionModal();
        permissionGranted();
        setAllowedToGiveTest(true);
    };

    useEffect(() => {
        if (isUnsupportedBrowser) {
            return;
        }
        // check if user has not accepted nda then user will show form
        if (result && result.is_nda === 0 && isNda) {
            setOpenNdaModal(true);
            setAllowedToGiveTest(false);
        }

        if (!isNda) {
            setOpenNdaModal(false);
            if (test.is_screen_recording_enabled !== 1) {
                setAllowedToGiveTest(true);
            }

            // check if it's a preview page
            if (location.pathname.slice(1, 2) === "p") {
                setAllowedToGiveTest(true);
                return;
            }
        }
    }, [isNda, location.pathname, result, test, isUnsupportedBrowser]);

    useEffect(() => {
        if (isUnsupportedBrowser) {
            return;
        }
        if (result && result.is_nda === 1) {
            if (test.is_screen_recording_enabled === 1) {
                setAllowedToGiveTest(false);
                setOpenPermissionModal(true);
            } else {
                setAllowedToGiveTest(true);
            }
        }
    }, [result, test, isUnsupportedBrowser]);

    if (isUnsupportedBrowser) {
        return null;
    }

    return (
        <div className="tester-page-wrapper tester-welcome-page-wrap">
            <div className="container inner-page-container">
                <div className="taking-test-page-height">
                    <div className="tester-screens-hold">
                        <div className="tester-selected-page-wrap">
                            <div className="selected-page-right-side">
                                <div className="tester-page-selected-img-wrap">
                                    {test.is_intro_img_removed === 1 &&
                                        test.image === null ? (
                                        <></>
                                    ) : (
                                        <img
                                            src={
                                                test && test.image
                                                    ? process.env.REACT_APP_IMG_URL + test.image
                                                    : process.env.REACT_APP_URL + "img/welcome-img.png"
                                            }
                                        />
                                    )}
                                </div>
                            </div>

                            <div
                                className={`selected-page-left-side ${test.language === "ar"
                                    ? "arabic_wrapper"
                                    : ""
                                    }`}
                            >
                                <Text type={"h1"}>
                                    {test && test.welcome_title}
                                </Text>

                                <Text
                                    type={"subtitle-2"}
                                    fontWeight={"medium-font"}
                                >
                                    {test && test.welcome_description}
                                </Text>

                                <div className="button-wrapper none-for-mobile">
                                    <Button
                                        size={"large"}
                                        iconRight={
                                            <Icon
                                                colorClass={"gray-50-svg"}
                                                value={
                                                    test &&
                                                        test.language === "ar"
                                                        ? "back-arrow"
                                                        : "forward-arrow"
                                                }
                                            />
                                        }
                                        label={
                                            test.language === "en"
                                                ? "Let's start"
                                                : "لنبدأ"
                                        }
                                        onClick={() => {
                                            if (test.is_screen_recording_enabled === 1) {
                                                if (allowedToGiveTest) {
                                                    introductionCallback(checkNda);
                                                } else {
                                                    window.location.reload();
                                                }
                                            } else {
                                                introductionCallback(checkNda);
                                            }
                                        }}
                                        state={
                                            allowedToGiveTest
                                                ? "active"
                                                : "disabled"
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="button-wrapper none-for-desktop taking-test-button">
                    <Button
                        size={"large"}
                        iconRight={
                            <Icon
                                colorClass={"gray-50-svg"}
                                value={
                                    test && test.language === "ar"
                                        ? "back-arrow"
                                        : "forward-arrow"
                                }
                            />
                        }
                        label={test.language === "en" ? "Let's start" : "لنبدأ"}
                        onClick={() => {
                            if (test.is_screen_recording_enabled === 1) {
                                if (allowedToGiveTest) {
                                    introductionCallback(checkNda);
                                } else {
                                    window.location.reload();
                                }
                            } else {
                                introductionCallback(checkNda);
                            }
                        }}
                        state={allowedToGiveTest ? "active" : "disabled"}
                    />
                </div>
            </div>
            <NdaModal
                timeSpent={timeSpent}
                result={result}
                isPaidUser={isPaidUser}
                isRegisteredUser={isRegisteredUser}
                score={score}
                // openModal={(result && test.methodology === 'Card Sorting' && result.device === 'Mobile')?false:openNdaModal}
                openModal={openNdaModal}
                closeModal={closeNdaModal}
                testLanguage={test.language}
                testDevice={test.device}
                methodology={test.methodology}
                testerLimitExceed={testerLimitExceed}
                testerNotMatchedInTargetGroup={testerNotMatchedInTargetGroup}
                isScreenRecordingEnabled={test.is_screen_recording_enabled}
            />
            <ScreenRecordingPermissionModal
                openModal={openPermissionModal}
                closeModal={closePermissionModal}
                requestAccepted={handlepermissionModal}
            />
        </div>
    );
}
